module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "text-xs-center": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isUpdateValid),
      callback: function($$v) {
        _vm.isUpdateValid = $$v
      },
      expression: "isUpdateValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.departmentList.length == 0) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Status Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Status Description",
      "rules": _vm.nameRules,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.objStatusEdit.description),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "description", $$v)
      },
      expression: "objStatusEdit.description"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.departmentList.length != 0) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Status Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Status Description",
      "rules": _vm.nameRules,
      "solo": "",
      "single-line": ""
    },
    model: {
      value: (_vm.objStatusEdit.description),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "description", $$v)
      },
      expression: "objStatusEdit.description"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Status Reasons: "), _c('small', [_vm._v("( Too expensive, Timing, Not needed anymore etc\n            )")])]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Status Reasons",
      "solo": "",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.objStatusEdit.reasons),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "reasons", $$v)
      },
      expression: "objStatusEdit.reasons"
    }
  })], 1), _vm._v(" "), (_vm.departmentList.length > 0 && _vm.fncCheckDeps()) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Status Department:")]), _vm._v(" "), _c('small', {
    staticStyle: {
      "display": "block",
      "float": "left",
      "font-size": "10px !important"
    }
  }, [_vm._v("These departments will have access to:\n            "), _c('strong', [_vm._v(_vm._s(_vm.globalModalParams.statusName))])]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.departmentList,
      "item-value": "id",
      "item-text": "name",
      "label": "Status Department",
      "autocomplete": "",
      "multiple": "",
      "solo": ""
    },
    model: {
      value: (_vm.objDepartments),
      callback: function($$v) {
        _vm.objDepartments = $$v
      },
      expression: "objDepartments"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.userRoles.length > 0 && _vm.departmentList.length != 0 && _vm.fncCheckDeps()) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Status Roles:")]), _vm._v(" "), _c('small', {
    staticStyle: {
      "display": "block",
      "float": "left",
      "font-size": "10px !important"
    }
  }, [_vm._v("These roles will be able to change a\n            quote to: "), _c('strong', [_vm._v(_vm._s(_vm.globalModalParams.statusName))])]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.userRoles,
      "item-value": "id",
      "item-text": "name",
      "label": "Status Role",
      "autocomplete": "",
      "multiple": "",
      "solo": ""
    },
    model: {
      value: (_vm.objRoles),
      callback: function($$v) {
        _vm.objRoles = $$v
      },
      expression: "objRoles"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_c('strong', [_vm._v("PIPELINE STATUS GROUPING *")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "disabled": _vm.currentSelected && _vm.currentSelected !== 'is_initial_engagement_quote',
      "label": "Initial Engagement & Quoting"
    },
    model: {
      value: (_vm.objStatusEdit.is_initial_engagement_quote),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_initial_engagement_quote", $$v)
      },
      expression: "objStatusEdit.is_initial_engagement_quote"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "disabled": _vm.currentSelected && _vm.currentSelected !== 'is_negotiating_customer_approval',
      "label": "Negotiating Customer Approval"
    },
    model: {
      value: (_vm.objStatusEdit.is_negotiating_customer_approval),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_negotiating_customer_approval", $$v)
      },
      expression: "objStatusEdit.is_negotiating_customer_approval"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "disabled": _vm.currentSelected && _vm.currentSelected !== 'is_manufacturer_fulfilment',
      "label": "Manufacturer & Fulfilment"
    },
    model: {
      value: (_vm.objStatusEdit.is_manufacturer_fulfilment),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_manufacturer_fulfilment", $$v)
      },
      expression: "objStatusEdit.is_manufacturer_fulfilment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "disabled": _vm.currentSelected && _vm.currentSelected !== 'is_cancelled_expired_rejected',
      "label": "Cancelled, Expired or Rejected"
    },
    model: {
      value: (_vm.objStatusEdit.is_cancelled_expired_rejected),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_cancelled_expired_rejected", $$v)
      },
      expression: "objStatusEdit.is_cancelled_expired_rejected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_c('strong', [_vm._v("GENERAL STATUS FLAGS")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Converted"
    },
    model: {
      value: (_vm.objStatusEdit.is_converted),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_converted", $$v)
      },
      expression: "objStatusEdit.is_converted"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "New Lead"
    },
    model: {
      value: (_vm.objStatusEdit.is_new_lead),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_new_lead", $$v)
      },
      expression: "objStatusEdit.is_new_lead"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Gathering Customer Requirements"
    },
    model: {
      value: (_vm.objStatusEdit.is_gathering_customer_reqs),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_gathering_customer_reqs", $$v)
      },
      expression: "objStatusEdit.is_gathering_customer_reqs"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Quote Sent - Following Up"
    },
    model: {
      value: (_vm.objStatusEdit.is_quote_sent),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_quote_sent", $$v)
      },
      expression: "objStatusEdit.is_quote_sent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Requote Requested"
    },
    model: {
      value: (_vm.objStatusEdit.is_requote_requested),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_requote_requested", $$v)
      },
      expression: "objStatusEdit.is_requote_requested"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Rejected"
    },
    model: {
      value: (_vm.objStatusEdit.is_rejected),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_rejected", $$v)
      },
      expression: "objStatusEdit.is_rejected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Awaiting Acceptance"
    },
    model: {
      value: (_vm.objStatusEdit.is_awaiting),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_awaiting", $$v)
      },
      expression: "objStatusEdit.is_awaiting"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Requirements Sent to Design Team"
    },
    model: {
      value: (_vm.objStatusEdit.is_reqs_sent_to_design_team),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_reqs_sent_to_design_team", $$v)
      },
      expression: "objStatusEdit.is_reqs_sent_to_design_team"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Quote Completed by Design team"
    },
    model: {
      value: (_vm.objStatusEdit.is_quote_completed_by_design_team),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_quote_completed_by_design_team", $$v)
      },
      expression: "objStatusEdit.is_quote_completed_by_design_team"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Accepted Status"
    },
    model: {
      value: (_vm.objStatusEdit.is_accepted),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_accepted", $$v)
      },
      expression: "objStatusEdit.is_accepted"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Cancel Status"
    },
    model: {
      value: (_vm.objStatusEdit.is_cancel),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_cancel", $$v)
      },
      expression: "objStatusEdit.is_cancel"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Expired Status"
    },
    model: {
      value: (_vm.objStatusEdit.is_expired),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_expired", $$v)
      },
      expression: "objStatusEdit.is_expired"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_c('strong', [_vm._v("STATUS API TRIGGERS")])])]), _vm._v(" "), (_vm.objAuthorize.manufacturer != '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Locks Quote"
    },
    model: {
      value: (_vm.objStatusEdit.is_lock),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_lock", $$v)
      },
      expression: "objStatusEdit.is_lock"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [(_vm.globalModalParams.hasCheckedOut == false || _vm.objStatusEdit.description == _vm.globalModalParams.hasCheckedOutText) ? _c('v-switch', {
    attrs: {
      "label": "Checked Out Online"
    },
    model: {
      value: (_vm.objStatusEdit.is_checked),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_checked", $$v)
      },
      expression: "objStatusEdit.is_checked"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.globalModalParams.hasCheckedOut == true && _vm.objStatusEdit.description != _vm.globalModalParams.hasCheckedOutText) ? _c('v-switch', {
    attrs: {
      "disabled": true,
      "label": "Checked Out Online"
    },
    model: {
      value: (_vm.objStatusEdit.is_checked),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_checked", $$v)
      },
      expression: "objStatusEdit.is_checked"
    }
  }) : _vm._e(), _vm._v(" "), _c('small', {
    staticStyle: {
      "float": "left",
      "display": "block",
      "margin-top": "-22px",
      "font-size": "10px"
    }
  }, [_vm._v("Reduces Stock")])], 1), _vm._v(" "), (_vm.objAuthorize.manufacturer != '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Show Order Button"
    },
    model: {
      value: (_vm.objStatusEdit.is_vendor),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_vendor", $$v)
      },
      expression: "objStatusEdit.is_vendor"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Customer Email Accept Final"
    },
    model: {
      value: (_vm.objStatusEdit.is_customer_accept_final),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_customer_accept_final", $$v)
      },
      expression: "objStatusEdit.is_customer_accept_final"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Customer Email Accept"
    },
    model: {
      value: (_vm.objStatusEdit.is_customer_accept),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_customer_accept", $$v)
      },
      expression: "objStatusEdit.is_customer_accept"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Customer Email Reject"
    },
    model: {
      value: (_vm.objStatusEdit.is_customer_reject),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_customer_reject", $$v)
      },
      expression: "objStatusEdit.is_customer_reject"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Request for Requote"
    },
    model: {
      value: (_vm.objStatusEdit.is_reorder),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_reorder", $$v)
      },
      expression: "objStatusEdit.is_reorder"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Dispatched Status"
    },
    model: {
      value: (_vm.objStatusEdit.is_dispatched),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_dispatched", $$v)
      },
      expression: "objStatusEdit.is_dispatched"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Picked Status"
    },
    model: {
      value: (_vm.objStatusEdit.is_picked),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_picked", $$v)
      },
      expression: "objStatusEdit.is_picked"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Print Status"
    },
    model: {
      value: (_vm.objStatusEdit.is_print),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_print", $$v)
      },
      expression: "objStatusEdit.is_print"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Send to Hybris Shopping List"
    },
    model: {
      value: (_vm.objStatusEdit.is_hybris),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_hybris", $$v)
      },
      expression: "objStatusEdit.is_hybris"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Send to Hybris Trolley"
    },
    model: {
      value: (_vm.objStatusEdit.is_hybris_trolley),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_hybris_trolley", $$v)
      },
      expression: "objStatusEdit.is_hybris_trolley"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Status that you cant move back from once payment has been made"
    },
    model: {
      value: (_vm.objStatusEdit.can_back_after_payment),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "can_back_after_payment", $$v)
      },
      expression: "objStatusEdit.can_back_after_payment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Status that you cant move passed before payment has been made"
    },
    model: {
      value: (_vm.objStatusEdit.can_forward_before_payment),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "can_forward_before_payment", $$v)
      },
      expression: "objStatusEdit.can_forward_before_payment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Manufactured Status"
    },
    model: {
      value: (_vm.objStatusEdit.is_manufactured),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_manufactured", $$v)
      },
      expression: "objStatusEdit.is_manufactured"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Delivered to Store Status"
    },
    model: {
      value: (_vm.objStatusEdit.is_delivered_to_store),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_delivered_to_store", $$v)
      },
      expression: "objStatusEdit.is_delivered_to_store"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Process Order"
    },
    model: {
      value: (_vm.objStatusEdit.is_process_order),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_process_order", $$v)
      },
      expression: "objStatusEdit.is_process_order"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Is Waiting For Tender"
    },
    model: {
      value: (_vm.objStatusEdit.is_waiting_tender),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_waiting_tender", $$v)
      },
      expression: "objStatusEdit.is_waiting_tender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Is POD Uploaded"
    },
    model: {
      value: (_vm.objStatusEdit.is_pod_uploaded),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_pod_uploaded", $$v)
      },
      expression: "objStatusEdit.is_pod_uploaded"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Ignore For Reporting"
    },
    model: {
      value: (_vm.objStatusEdit.is_ignore),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_ignore", $$v)
      },
      expression: "objStatusEdit.is_ignore"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Send To Customer"
    },
    model: {
      value: (_vm.objStatusEdit.is_customer_send),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_customer_send", $$v)
      },
      expression: "objStatusEdit.is_customer_send"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "PO Received"
    },
    model: {
      value: (_vm.objStatusEdit.is_po_received),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_po_received", $$v)
      },
      expression: "objStatusEdit.is_po_received"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Can Repeat Status From Email Button"
    },
    model: {
      value: (_vm.objStatusEdit.is_status_repeat),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_status_repeat", $$v)
      },
      expression: "objStatusEdit.is_status_repeat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Status Color:")]), _vm._v(" "), _c('swatches', {
    attrs: {
      "colors": "text-advanced",
      "popover-to": "right"
    },
    model: {
      value: (_vm.objStatusEdit.style_colour),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "style_colour", $$v)
      },
      expression: "objStatusEdit.style_colour"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Status Color:")]), _vm._v(" "), _c('swatches', {
    attrs: {
      "colors": "text-advanced",
      "popover-to": "right"
    },
    model: {
      value: (_vm.objStatusEdit.style_colour),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "style_colour", $$v)
      },
      expression: "objStatusEdit.style_colour"
    }
  })], 1), _vm._v(" "), (_vm.objAuthorize.manufacturer != '385889803') ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_c('strong', [_vm._v("E-COMMERCE FLAG STATUS")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.hide_ecommerce == 1) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Payment Cancelled"
    },
    model: {
      value: (_vm.objStatusEdit.is_ecommerce_cancelled),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_ecommerce_cancelled", $$v)
      },
      expression: "objStatusEdit.is_ecommerce_cancelled"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.hide_ecommerce == 1) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Payment Pending"
    },
    model: {
      value: (_vm.objStatusEdit.is_ecommerce_pending),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_ecommerce_pending", $$v)
      },
      expression: "objStatusEdit.is_ecommerce_pending"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.hide_ecommerce == 1) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Payment Successful"
    },
    model: {
      value: (_vm.objStatusEdit.is_ecommerce_success),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_ecommerce_success", $$v)
      },
      expression: "objStatusEdit.is_ecommerce_success"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.hide_ecommerce == 1) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Payment Failed"
    },
    model: {
      value: (_vm.objStatusEdit.is_ecommerce_failed),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_ecommerce_failed", $$v)
      },
      expression: "objStatusEdit.is_ecommerce_failed"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer != '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Is Delivered"
    },
    model: {
      value: (_vm.objStatusEdit.is_delivered),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_delivered", $$v)
      },
      expression: "objStatusEdit.is_delivered"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_c('strong', [_vm._v("4SURE STATUSES")])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Installation In Progress Status"
    },
    model: {
      value: (_vm.objStatusEdit.is_installation_wip),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_installation_wip", $$v)
      },
      expression: "objStatusEdit.is_installation_wip"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Installation Complete Status"
    },
    model: {
      value: (_vm.objStatusEdit.is_installation_work_complete),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "is_installation_work_complete", $$v)
      },
      expression: "objStatusEdit.is_installation_work_complete"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Job Completed"
    },
    model: {
      value: (_vm.objStatusEdit.fs_job_complete),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "fs_job_complete", $$v)
      },
      expression: "objStatusEdit.fs_job_complete"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Job Cancelled"
    },
    model: {
      value: (_vm.objStatusEdit.fs_job_cancelled),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "fs_job_cancelled", $$v)
      },
      expression: "objStatusEdit.fs_job_cancelled"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Awaiting Stock"
    },
    model: {
      value: (_vm.objStatusEdit.fs_awaiting_stock),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "fs_awaiting_stock", $$v)
      },
      expression: "objStatusEdit.fs_awaiting_stock"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "TL On Site"
    },
    model: {
      value: (_vm.objStatusEdit.fs_on_site),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "fs_on_site", $$v)
      },
      expression: "objStatusEdit.fs_on_site"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Work Paused"
    },
    model: {
      value: (_vm.objStatusEdit.fs_work_paused),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "fs_work_paused", $$v)
      },
      expression: "objStatusEdit.fs_work_paused"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "No Appointment"
    },
    model: {
      value: (_vm.objStatusEdit.fs_no_appointment_contact_customer),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "fs_no_appointment_contact_customer", $$v)
      },
      expression: "objStatusEdit.fs_no_appointment_contact_customer"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Ready For Delivery"
    },
    model: {
      value: (_vm.objStatusEdit.fs_delivery_ready),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "fs_delivery_ready", $$v)
      },
      expression: "objStatusEdit.fs_delivery_ready"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Installer Allocated"
    },
    model: {
      value: (_vm.objStatusEdit.fs_installer_allocated),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "fs_installer_allocated", $$v)
      },
      expression: "objStatusEdit.fs_installer_allocated"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Installer On Route - Stock Collect"
    },
    model: {
      value: (_vm.objStatusEdit.fs_installer_on_route_stock_collect),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "fs_installer_on_route_stock_collect", $$v)
      },
      expression: "objStatusEdit.fs_installer_on_route_stock_collect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Installer At Dispatch"
    },
    model: {
      value: (_vm.objStatusEdit.fs_installer_at_dispatch),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "fs_installer_at_dispatch", $$v)
      },
      expression: "objStatusEdit.fs_installer_at_dispatch"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Collection Cancelled"
    },
    model: {
      value: (_vm.objStatusEdit.fs_collection_cancelled),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "fs_collection_cancelled", $$v)
      },
      expression: "objStatusEdit.fs_collection_cancelled"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Installer On Route - Customer"
    },
    model: {
      value: (_vm.objStatusEdit.fs_installer_on_route_customer),
      callback: function($$v) {
        _vm.$set(_vm.objStatusEdit, "fs_installer_on_route_customer", $$v)
      },
      expression: "objStatusEdit.fs_installer_on_route_customer"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-2 buttonHolder",
    staticStyle: {
      "margin-bottom": "0px !important"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.statusEdit == true) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runEdit && _vm.statusEdit == false) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": !_vm.update_vars
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateStatus()
      }
    }
  }, [_vm._v("Update\n            ")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}